// src/pages/SocialMediaPage.js
import React from "react";
// 👇 Importando os ícones oficiais das marcas via react-icons
import { FaInstagram, FaTiktok, FaFacebook } from "react-icons/fa6";

import Config from "../Config.json";
import styles from "../assets/css/LinkTree.module.css";
import profilepic from "../assets/images/pfp.png";
import ICON from "../assets/icons/favicon.ico";

const TITLE = Config.SITE_TITLE + " - Redes Sociais";
const DESC = "Nossas Redes Sociais - Board Game Café do Cariri";
const CANONICAL = Config.SITE_DOMAIN + "/social";

function SocialMediaPage() {
  return (
    <main className={styles.container}>
      <title>{TITLE}</title>
      <link rel="icon" href={ICON} />
      <link rel="canonical" href={CANONICAL} />
      <meta name="description" content={DESC} />
      
      <div className={styles.header}>
        <figure className={styles.avatar}>
          <img src={profilepic} alt="Deli da Persy" />
        </figure>
        <h1 className={styles.title}>Deli da Persy</h1>
        <h2 className={styles.subtitle}>☕ Board Game Café</h2>
      </div>

      {/* Substitua os links nos href pelas URLs reais das páginas da Deli da Persy */}
      <a href="https://www.instagram.com/delidapersy" target="_blank" rel="noopener noreferrer">
        <button className={styles.button}>
            Instagram <FaInstagram size={18} className={styles.buttonIcon} />
        </button>
      </a>
      
      <a href="https://www.tiktok.com/@delidapersy" target="_blank" rel="noopener noreferrer">
        <button className={styles.button}>
            TikTok <FaTiktok size={18} className={styles.buttonIcon} />
        </button>
      </a>

      
      <a href="https://www.facebook.com/DelidaPersy" target="_blank" rel="noopener noreferrer">
        <button className={styles.button}>
            Facebook <FaFacebook size={18} className={styles.buttonIcon} />
        </button>
      </a>

    </main>
  );
}

export default SocialMediaPage;